import { Component, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { SrcInterviewService } from 'src/app/modules/interview/src-interview.service';
import { CommonService } from 'src/app/services/common.service';
import { Utility } from 'src/app/shared/utility/utility';


@Component({
  selector: 'app-scr-interview',
  templateUrl: './src-interview.component.html',
  styleUrls: ['./src-interview.component.scss']
})


export class SrcInterviewComponent implements OnInit {

  lstInterviewSheet: any;
  userID: '';
  constructor(
    private interviewService: SrcInterviewService,
    private loading: LoadingService,
    private common: CommonService,
    public util: Utility,

  ) { }

  ngOnInit(): void {
    this.util.resetZoomBrowser();
    this.userID = JSON.parse(localStorage.getItem('ExamineauthorizationData')).UserID;
    this.getInterviewSheet();
  }

  getInterviewSheet() {
    const obj = {
      UserID: this.userID,
      RsvDate: '20210705',
      RsvNum: '007'
    };
    this.loading.setDisplay(true);
    this.interviewService.getInterviewSheet(obj).subscribe(res => {
      this.lstInterviewSheet = res.Data;
      if (this.lstInterviewSheet.length > 0) {
        this.lstInterviewSheet[0].active = true;
      }
      console.log(this.lstInterviewSheet, 'lstInterviewSheet')
      this.loading.setDisplay(false);
    }, err => {
      this.loading.setDisplay(false);

    }

    );

  }

}
